import React, { useState, useEffect } from 'react';
import {
  Box,
  Input,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Tag,
  Flex,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
} from '@chakra-ui/react';
import axios from 'axios';

const SpecializationPool = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [newName, setNewName] = useState('');
  const [newId, setNewId] = useState('');
  const [newDescription, setNewDescription] = useState('');
  const [data, setData] = useState([]);
  const [selectedSpecialization, setSelectedSpecialization] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    fetchSpecializations();
  }, []);

  const fetchSpecializations = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/admin/get-specializations`,{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      setData(response.data.data);
    } catch (error) {
      console.error('Error fetching specializations:', error);
    }
  };

  const handleAdd = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      const newSpecialization = { name: newName, specializationId: newId, description: newDescription };
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/admin/add-specialization`, newSpecialization,{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      fetchSpecializations();
      setNewName('');
      setNewId('');
      setNewDescription('');
      onClose();
    } catch (error) {
      console.error('Error adding specialization:', error);
    }
  };

  const handleUpdate = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      await axios.put(`${process.env.REACT_APP_SERVER_URL}/admin/update-specialization/${selectedSpecialization._id}`, selectedSpecialization,{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      fetchSpecializations();
      onClose();
    } catch (error) {
      console.error('Error updating specialization:', error);
    }
  };

  const handleEdit = (specialization) => {
    setSelectedSpecialization(specialization);
    onOpen();
  };

  const filteredData = data.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box p={4}>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <Heading>Specializations Pool</Heading>
        <Button colorScheme="teal" onClick={onOpen} position="absolute" top="10px" right="10px" zIndex="1000">
          Add
        </Button>
      </Flex>

      <Input
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        mb={4}
      />

      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>ID</Th>
            <Th>Description</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {filteredData.map((item, index) => (
            <Tr key={index}>
              <Td>
                <Tag>{item.name}</Tag>
              </Td>
              <Td>{item.specializationId}</Td>
              <Td>{item.description}</Td>
              <Td>
                <Button size="sm" colorScheme="blue" onClick={() => handleEdit(item)}>
                  Edit
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{selectedSpecialization ? 'Edit Specialization' : 'Add New Specialization'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input
                placeholder="Name"
                value={selectedSpecialization ? selectedSpecialization.name : newName}
                onChange={(e) => selectedSpecialization ? setSelectedSpecialization({ ...selectedSpecialization, name: e.target.value }) : setNewName(e.target.value)}
                mb={2}
              />
            </FormControl>
            <FormControl>
              <FormLabel>ID</FormLabel>
              <Input
                placeholder="ID"
                value={selectedSpecialization ? selectedSpecialization.specializationId : newId}
                onChange={(e) => selectedSpecialization ? setSelectedSpecialization({ ...selectedSpecialization, specializationId: e.target.value }) : setNewId(e.target.value)}
                mb={2}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Description</FormLabel>
              <Input
                placeholder="Description"
                value={selectedSpecialization ? selectedSpecialization.description : newDescription}
                onChange={(e) => selectedSpecialization ? setSelectedSpecialization({ ...selectedSpecialization, description: e.target.value }) : setNewDescription(e.target.value)}
                mb={2}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={selectedSpecialization ? handleUpdate : handleAdd}>
              {selectedSpecialization ? 'Update' : 'Submit'}
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default SpecializationPool;